import { styled } from '@mui/material';

import { Skeleton } from '../../atoms/Skeleton';
import { MEMBER_AVATAR_SIZE, MEMBER_LIST_WIDE_QUERY } from '../MemberList/memberListContainer';

const Row = styled('li')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${MEMBER_AVATAR_SIZE}px minmax(0, 1fr)`,
  columnGap: theme.spacing(1.5),
  alignItems: 'center',
  minHeight: theme.spacing(9),
  paddingBlock: theme.spacing(1.5),
  paddingInline: theme.spacing(2),
  [MEMBER_LIST_WIDE_QUERY]: {
    columnGap: theme.spacing(2),
  },
}));

const Lines = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

/** Placeholder mirroring a `MemberListItem` while the members load. */
export function MemberListItemSkeleton() {
  return (
    <Row aria-hidden="true">
      <Skeleton variant="circular" width={MEMBER_AVATAR_SIZE} height={MEMBER_AVATAR_SIZE} />
      <Lines>
        <Skeleton variant="text" width="40%" />
        <Skeleton variant="text" width="65%" />
      </Lines>
    </Row>
  );
}
